//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Annotations/Annotations.TextWithEditControlsBuilder.js";
import "../no/Annotations.js";
import "../no/Routing.js";
let d=[[[0,"ExpressionName",0,0],[0,"FirstEndPoint",1,"Point",0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"RouteObjectCollector",0,"Routing.RouteObjectCollector",0],[0,"SecondEndPoint",1,"Point",0],[0,"ShowLeadersToggle",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[1,"Text",0,"Annotations.TextWithEditControlsBuilder",0],[0,"Type",1,0]],[[["firstEndPoint","secondEndPoint"],"SetPathLengthAnnotationEndPoints",{},2,0],[["firstEndRcp","secondEndRcp"],"CreatePointsAtRcps",{},2,0]],[]];
SPLM.Formboard.PathLengthAnnotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.PathLengthAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.PathLengthAnnotationBuilder.Types = Object.freeze({
    "PointsOnCurves" : "PointsOnCurves", "RoutingPathLength" : "RoutingPathLength"});

export default SPLM;